import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import "./SubscriptionLogoutButton.scss";
import Swal from "sweetalert2";

const SubscriptionLogoutButton = () => {
    let navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("subscriptionUser");

        Swal.fire({
            title: "Logged Out",
            text: "You have been logged out of your subscription account.",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3f51b5",
            showClass: {
                popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
                popup: "animate__animated animate__fadeOutUp",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/");
                window.location.reload();
            }
        });
    }


    return (
        <Button className={"signOutButton"} fillMode={"link"} onClick={() => handleLogout()}>
            <span className="k-icon k-i-logout">&nbsp;</span>Subscriptions Logout
        </Button>
    );
};

export default SubscriptionLogoutButton